import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const getDistanceUnitData = async (accountId, cspOrCaseId, userId) => {
  try {
    return await getRequest(urls.GET_CSP_DETAILS + `/${accountId}` + `/${cspOrCaseId}` + `/${userId}`);
  } catch (err) {
    return err;
  }
};
